import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { INonModelPage } from '../../model-system/paged-model';
import { ApiService } from '../../services/api.service';
import { Group, NewGroup } from './group';

@Injectable()
export class GroupService {
  private readonly baseUri = '/platform/api/v2/groups';

  constructor(public api: ApiService) {}

  public get(id: string): Observable<Group> {
    return this.api.get(`${this.baseUri}/${id}`);
  }

  public getPage({
    pageNumber,
    pageSize,
    name,
    state
  }: GroupSearchParams): Observable<INonModelPage<Group>> {
    const query: GroupQuery = {
      pageNumber,
      pageSize,
      sortBy: 'name',
      sortOrder: 'ASC',
      query: [
        {
          type: 'EXACT',
          value: state,
          fields: ['state'],
          operator: 'AND'
        }
      ]
    };

    if (typeof name === 'string' && name) {
      query.query.push({
        type: 'STARTS_WITH',
        value: name,
        fields: ['name']
      });
    }

    return this.api.post(`${this.baseUri}/search`, query).pipe(
      map((data) => ({
        entities: data.results ? data.results : [],
        nextUri: data.nextPage,
        previousUri: data.previousPage
      }))
    );
  }

  public getPageWithUri(uri: string): Observable<INonModelPage<Group>> {
    return this.api.get(uri).pipe(
      map((data) => ({
        entities: data.results ? data.results : [],
        nextUri: data.nextPage,
        previousUri: data.previousPage
      }))
    );
  }

  public createGroup(group: NewGroup): Observable<Group> {
    return this.api.post(this.baseUri, group);
  }

  public saveGroup(group: Group): Observable<Group> {
    return this.api.put(`${this.baseUri}/${group.id}`, group);
  }

  public deleteGroup(id: string): Observable<void> {
    return this.api.delete(`${this.baseUri}/${id}`);
  }

  public assignDID(group: Group, number: string): Observable<boolean> {
    if (group.addresses) {
      group.addresses.push({ address: number, type: 'GROUPPHONE', mediaType: 'PHONE' });
    } else {
      group.addresses = [{ address: number, type: 'GROUPPHONE', mediaType: 'PHONE' }];
    }

    return this.saveGroup(group).pipe(map(() => true));
  }
}

interface GroupSearchParams {
  pageNumber: number;
  pageSize: number;
  name?: string;
  state: string;
}

interface GroupQuery {
  pageSize: number;
  pageNumber: number;
  sortBy: string;
  sortOrder: 'ASC' | 'DESC';
  query?: any[];
}
